import { BaseNotification } from '@/modules/Notifications/helpers/types';
import { useCallback, useMemo } from 'react';
import { ErrorMessageServiceConnector } from '@/modules/api/ErrorMessageServiceConnector/ErrorMessageServiceConnector';

export const useNotificationMessageApi = () => {
  const api = useMemo(() => ErrorMessageServiceConnector.getInstance(), []);

  const getNotificationDetails = useCallback(
    async (code: string): Promise<BaseNotification> => {
      if (!code) {
        return Promise.reject();
      }

      return api.getNotificationDetails(code);
    },
    [api],
  );

  return { getNotificationDetails };
};
